import { defineStore } from 'pinia'
import { HttpTransportType, HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr'

export const useSignalRStore = defineStore('signalr', {
  state: () => ({
    connection: null as HubConnection | null,
    startedPromise: null as Promise<void> | null,
    manuallyClosed: false,
    // eventHub:     ,

    deviceUpdated: null,
  }),
  actions: {
    startSignalR(jwtToken: string) {
      this.connection = new HubConnectionBuilder()
        .withUrl(new URL('/ws/eventHub', window.Config.BaseURL).toString(), {
          accessTokenFactory: () => jwtToken,
          transport: HttpTransportType.WebSockets,
        })
        .configureLogging(LogLevel.Information)
        .withAutomaticReconnect()
        .build()

      this.connection.on('version_changed', (version) => {
        console.log(version)
      })
      this.connection.on('PushNotification', (content) => {
        console.log(content)
      })
      this.connection.on('WebNotification', (content) => {
        console.log(content)
      })

      const start = (): Promise<void> => {
        if (!this.connection) return Promise.resolve()

        return this.connection.start().catch((err) => {
          console.error('Failed to connect with hub', err)
          return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000))
        })
      }

      start()
    },
    stopSignalR() {
      if (this.connection) {
        this.connection.stop()
        this.connection = null
      }
    },
  },
})
